import { Frame } from '@shopify/polaris';
import { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import api from '../../helpers/api';
import formatErrors from '../../helpers/format_errors';
import LocationForm from './Form';

const CreateLocation = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [location, setLocation] = useState({
        billing: null,
        shipping: {
            address1: '',
            address2: '',
            company: '',
            city: '',
            zip_code: '',
            state: '',
            country: '',
            type: '',
        },
        phone: '',
        default: false,
        card: null,
        credit_card_id: null,
        notes: '',
        credit_enabled: false,
        credit_balance: 0,
    });

    const [errors, setErrors] = useState({});
    const {customerId} = useParams();

    const handleSubmit = () => {
        setErrors({});
        setLoading(true);

        api.createLocation(customerId, location).then((response) => {
            setLoading(false);
            history.push(`/locations/${response.data.data.id}?created=1`)
        }).catch(error => {
            setLoading(false);
            if ( error?.response?.status == 422 ) {
                setErrors(formatErrors( error.response.data ));
            } else {
                throw error;
            }
        });
    }

    return location && (
        <Frame>
            <LocationForm
                customerId={customerId}
                location={location}
                setLocation={setLocation}
                handleSubmit={handleSubmit}
                errors={errors}
                loading={loading}
                setLoading={setLoading}
            />
        </Frame>
    );
}

export default CreateLocation;
